import Sidebar from "../components/Sidebar.js";
import Header from "../components/Header.js";
import remarksData from "../components/remarks.json";
import RemarkCard from "../components/RemarkCard.js";

function Remarks() {
  return (
    <div className="App flex flex-row">
      <Sidebar />
      <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
        <Header title={"Remarks"} date="Sunday, 22 Dec 2024" colour="#c82333" />
        <a href="/remarks/id">
          {remarksData.map((card) => (
            <RemarkCard
              companyName={card.companyName}
              date={card.date}
              remark={card.detailedFeedback}
            />
          ))}
        </a>
      </div>
    </div>
  );
}
export default Remarks;
